module.exports = __webpack_public_path__ + "static/media/STEP2.3f6917a4.png";